import React from 'react'
import { Box } from '@mui/material'
import { controlTowerSignalColumnSx } from './controlTowerStyles'

interface ControlTowerRosterColumnsProps {
  showPlayedColumn: boolean
}

/** The roster's column widths, shared by its header and its rows so the two line up. */
export const ControlTowerRosterColumns: React.FC<ControlTowerRosterColumnsProps> = ({ showPlayedColumn }) => (
  <colgroup>
    <col />
    <Box component="col" sx={controlTowerSignalColumnSx} />
    {showPlayedColumn && <Box component="col" sx={controlTowerSignalColumnSx} />}
  </colgroup>
)
